<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import api from "@/axios"
import moment from "moment/moment";
import Loader from "../../components/loader";
import Stat from "@/components/widgets/stat.vue";
import {ref} from "vue";
import Swal from 'sweetalert2';
import {getBaseUrl} from "@/helpers/baseUrl";

/**
 * Projects-grid component
 */
export default {
  page: {
    title: "",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Stat,
    Layout,
    PageHeader,
    Loader,
  },
  data() {
    return {
      title: "",
      items: [
        {
          text: "transportador",
          href: "/cte-entrada-list",
        },
        {
          text: "resumo",
          active: true,
        },
      ],

      gradientBackground: {
        background: 'linear-gradient(to bottom, #b1b1b1, #e8e9eb)'
      },

      totalizadores: {},
      userLogged: {},
      listaResultado: {},
      nomeEstado: "",
      showModalPeriodo: false,
      dtFimFormated: null,
      dtIniFormated: null,
      dtIniFiltro: null,
      dtFimFiltro: null,
      dtIniFiltroFormated: null,
      dtFimFiltroFormated: null,

      submittedPeriodo: null,
      qtdItens: 0,
      updating: true,
      chartFreteMes: [
        {
          name: "Frete %",
          data: [0,0,0,0,0,0,0,0,0,0,0,0],
        }
      ],
      fretekilotop: 0,

      selectedDropdown: null,

      cardsData: [],
      exibEmit: true,
      exibDest: false,
      exibAmbos: false,

      chartOptions: {
        chart: {
          height: 320,
          type: "line",
          toolbar: "false",
          dropShadow: {
            enabled: true,
            color: "#000",
            top: 18,
            left: 7,
            blur: 8,
            opacity: 0.2,
          },
        },
        dataLabels: {
          enabled: true,
          background: {
            enabled: false,
          },
          style: {
            colors: ['#333'],
            fontSize: '12px',
            fontWeight: 'bold',
          },
          offsetY: -10,
          offsetX: 3,
        },
        colors: ["#556ee6"],
        stroke: {
          curve: "smooth",
          width: 3,
        },
        xaxis: {
          categories:["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
          min: 1,
          max: 12,
        },
        yaxis: {
          labels: {
            formatter: function (value) {
              return value + "% ";
            },
          },
          title: {
            text: "Frete %",
            style: {
              fontSize: '16px',
              fontWeight: 'bold',
              color: '#333',
            }
          },
        },
      },
    };
  },

  created() {
    this.dtIniFiltro = moment().subtract(30, 'days').startOf('day').format('YYYY-MM-DD 00:00:00'); //Recuperando primeiro dia do mês
    this.dtFimFiltro = moment().endOf('day').format('YYYY-MM-DD 23:59:59'); //Recuperando data atual
  },

  computed: {
    chunkedListaResultado() {
      const chunkSize = 4;
      const chunkedArray = [];
      for (let i = 0; i < this.listaResultado.length; i += chunkSize) {
        chunkedArray.push(this.listaResultado.slice(i, i + chunkSize));
      }
      return chunkedArray;
    },
    chunkedEstadoDestaque() {
      const chunkSize = 1;
      const chunkedArray = [];
      for (let i = 0; i < this.listaResultado.length; i += chunkSize) {
        chunkedArray.push(this.listaResultado.slice(i, i + chunkSize));
      }
      return chunkedArray;
    },
  },

  setup() {
    const isOpen1 = ref(false);

    return {
      isOpen1,
    };
  },

  methods: {
    handleCheckbox(checkbox) {
      if (checkbox === 'exibEmit') {
        this.exibDest = false;
        this.exibAmbos = false;
      } else if (checkbox === 'exibDest') {
        this.exibEmit = false;
        this.exibAmbos = false;
      } else if (checkbox === 'exibAmbos') {
        this.exibEmit = false;
        this.exibDest = false;
      }

      this.atualizaDataList();
    },

    confirmarPeriodo() {
      console.log('confirmarPeriodo')

      localStorage.setItem('filtros', JSON.stringify({
        'movdi': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
        'movdf': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
      }))

      this.showModalPeriodo = false
      this.atualizaDataList()
    },

    atualizaDataList() {
      console.log("atualizaDataList");
      this.updating = true

      const filtros = JSON.parse(localStorage.getItem("filtros"))

      if (!filtros) {
        console.log('cookie dataMov não existe, criando')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': perIniPadrao,
          'movdf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['movdi']
        this.dtFimFiltro = filtros['movdf']
      }

      if (!this.dtIniFiltro && !this.dtFimFiltro) {
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }

      const exibEmit = this.exibEmit
      const exibDest = this.exibDest
      const exibAmbos = this.exibAmbos
      const di = this.dtIniFiltro
      const df = this.dtFimFiltro
      const paramsReq = {
        'ee': exibEmit,
        'ed': exibDest,
        'ea': exibAmbos,
        'di': di,
        'df': df
      }

      api.get(`${getBaseUrl()}api/movctedash2`, {
        params: paramsReq
      }).then((res) => {
        console.log('response')
        console.log(res);

        this.trataRetorno(res);
        this.updating = false
      });
    },


    trataRetorno(res) {
      console.log('trataRetorno');

      if (res.status === 204) {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "Não há nenhum registro conforme parametro enviado!",
          showConfirmButton: false,
          timer: 5000
        });

      } else {

        this.listaResultado = res.data.movCtes;

        this.listaResultado.forEach((value) => {
          console.log('value')
          console.log(value)

          value.freteKg = parseFloat(value.freteKg)
        })

        if (typeof res.data.dtIniFiltro === 'string' && typeof res.data.dtFimFiltro === 'string') {

          this.dtIniFormated = res.data.dtIniFiltro.split('-');
          this.dtIniFormated = `${this.dtIniFormated[2].substr(0, 2)}/${this.dtIniFormated[1]}/${this.dtIniFormated[0]}`;

          this.dtFimFormated = res.data.dtFimFiltro.split('-');
          this.dtFimFormated = `${this.dtFimFormated[2].substr(0, 2)}/${this.dtFimFormated[1]}/${this.dtFimFormated[0]}`;

          this.title = `Resumo estados: ${this.dtIniFormated} - ${this.dtFimFormated}`;

          if (this.listaResultado.length > 0) {
            const nomeEstadoArray = this.listaResultado[0].estado.split(" ");

            this.nomeEstado =
                nomeEstadoArray.slice(0, 2).join(" ") +
                " " +
                nomeEstadoArray.slice(2, 3).join(" ");
          }

          this.qtdItens = this.listaResultado.length;

          this.totalizadores = res.data.totalizadores

          this.totalizadores.totmovcte = parseInt(this.totalizadores.totmovcte)
          this.totalizadores.valcarctemes = parseFloat(this.totalizadores.valcarctemes)
          this.totalizadores.valfretctemes = parseFloat(this.totalizadores.valfretctemes)
          this.totalizadores.valpesoctemes = parseFloat(this.totalizadores.valpesoctemes)
          this.totalizadores.valorfretekg = parseFloat(this.totalizadores.valorfretekg).toFixed(2);
          this.totalizadores.valorfretperc = parseFloat(this.totalizadores.valorfretperc).toFixed(3);
          this.totalizadores.valorfretmedia = parseFloat(this.totalizadores.valorfretmedia).toFixed(2);
          this.totalizadores.ticketmedio = parseFloat(this.totalizadores.ticketmedio).toFixed(2);

          this.chartFreteMes = res.data.chartFreteMes;

        } else {
          console.error('Formato de data inválido:', res.data.dtIniFiltro, res.data.dtFimFiltro);
        }

        if (this.listaResultado) {
          this.selectedDropdown = this.listaResultado[0];
        }
      }
    },

    handleScroll() {
      if (this.$refs.current.$el) {
        setTimeout(() => {
          this.$refs.current.SimpleBar.value.getScrollElement().scrollTop =
              this.$refs.current.SimpleBar.value.getScrollElement().scrollHeight + 1500;
        }, 500);
      }
    },

    formatDecimal(value) {
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 3});
      }
      return 0.00;
    },

    formatInteger(value) {
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

  },

  mounted() {
    console.log('mounted_dashEstado ')
    this.atualizaDataList();

  },
};

</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" @click="showModalPeriodo=true"/>

    <div v-if="(qtdItens == 0 || qtdItens == null) && !updating" class="alert alert-danger" role="alert">
      Não existe informações para o período informado
    </div>

    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>

    <div class="row" v-if="!updating">
      <div class="col-lg-12">
        <div class="card bg-soft bg-primary">
          <div class="card-body" style="margin-bottom: -3ch;">
            <div class="row">
              <img
                  src="@/assets/images/transporte.png"
                  alt
                  class="img-fluid"
                  style="position: absolute; top:8ch; left: 15ch; width: 35ch; height: auto;"
              />

              <div class="col-lg-3">
                <div class="d-flex">
                  <div class="flex-grow-1 me-2 align-self-center col-lg-3">
                    <h5 class="text-primary font-size-18">Bem vindo!</h5>
                    <p>Dashboard de Transportadora por Estado</p>

                    <div class="row justify-content-left">
                      <div class="col-6 mt-3">

                        <span class=" text-primary font-size-14">Quant. de CTe's: </span>
                        <h5 class=" font-size-16">{{ formatInteger(totalizadores.totmovcte) }} CTe's</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-8 mt-3 mt-lg-0 align-self-center">
                <div class="row">
                  <div class="card">
                    <div class="mb-2 mt-2 p-1">
                      <div class="d-flex flex-wrap justify-content-center">
                        <h5 class="card-title font-size-16 mb-2"> Análise de Dados Mês </h5>
                      </div>

                      <div class="d-flex justify-content-center mt-2">
                        <div class="row col-xl-2">
                          <ul class="ps-0 mb-0" style="align-content: center; text-align: center">
                            <li class="ps-0 mb-0" :style="{ 'list-style-type': 'none' }">
                              <div class="justify-content-between align-items-center">
                                <div :style="{ 'margin-left': '10px' }">
                                  <i class="bx bx-archive-in me-2"></i>
                                  <a class="font-weight-semibold font-size-12 ">Valor Carga: </a>
                                </div>
                                <div class="d-inline">
                                  <a class="badge badge-soft-warning text-dark font-size-16" style="min-width: 14ch">R$
                                    {{ formatDecimal(totalizadores.valcarctemes) }}</a>
                                </div>
                              </div>
                            </li>
                          </ul>

                          <ul class="ps-0 mb-0" style="align-content: center; margin-top: 2ch; text-align: center ">
                            <li class="ps-0 mb-0" :style="{ 'list-style-type': 'none' }">
                              <div class="justify-content-between align-items-center">
                                <div :style="{ 'margin-left': '10px' }">
                                  <i class="bx bx-purchase-tag-alt me-2"></i>
                                  <a class="font-weight-semibold font-size-12">Valor Frete: </a>
                                </div>
                                <div class="d-inline">
                                  <a class="badge badge-soft-warning text-dark font-size-16 mb-1" style="min-width: 14ch">R$
                                    {{ formatDecimal(totalizadores.valfretctemes) }}</a>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>

                        <div class="col-xl-1"
                             style="float:left; max-width:360px;max-height:360px;margin-left:50px; border-left:1px solid #c5c6ca"></div>

                        <div class="row col-xl-2">
                          <ul class="ps-0 mb-0" style="align-content: center; text-align: center">
                            <li class="ps-0 mb-0" :style="{ 'list-style-type': 'none' }">
                              <div class="justify-content-between align-items-center">
                                <div>
                                  <i class="bx bx-copy-alt me-2"></i>
                                  <a class="font-weight-semibold font-size-12">CTe's Emitidos:</a>
                                </div>
                                <div class="d-inline" >
                                  <a class="badge badge-soft-warning text-dark font-size-16 mb-1" style="min-width: 14ch">
                                    {{ formatInteger(totalizadores.totmovcte) }} CTe's</a>
                                </div>
                              </div>
                            </li>
                          </ul>
                          <ul class="ps-0 mb-0" style="align-content: center; margin-top: 2ch; text-align: center">
                            <li class="ps-0 mb-0" :style="{ 'list-style-type': 'none' }">
                              <div class="justify-content-between align-items-center">
                                <div :style="{ 'margin-left': '10px' }">
                                  <i class="bx bx-purchase-tag-alt me-2"></i>
                                  <a class="font-weight-semibold font-size-12">Peso: </a>
                                </div>
                                <div class="d-inline">
                                  <a class="badge badge-soft-warning text-dark font-size-16 mb-1" style="min-width: 14ch">
                                    {{ formatDecimal(totalizadores.valpesoctemes) }} Kg</a>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>

                        <div class="col-xl-1"
                             style="float:left; max-width:360px;max-height:360px;margin-left:50px; border-left:1px solid #c5c6ca"></div>

                        <div class="row col-xl-2">
                          <ul class="ps-0 mb-0" style="align-content: center; text-align: center">
                            <li class="ps-0 mb-0" :style="{ 'list-style-type': 'none' }">
                              <div class="justify-content-between align-items-center">
                                <div>
                                  <i class="bx bx-purchase-tag-alt me-2"></i>
                                  <a class="font-weight-semibold font-size-12">Ticket Médio:</a>
                                </div>
                                <div class="d-inline" >
                                  <a class="badge badge-soft-warning text-dark font-size-16 mb-1" style="min-width: 14ch">R$
                                    {{ formatInteger(this.totalizadores.ticketmedio) }}</a>
                                </div>
                              </div>
                            </li>
                          </ul>
                          <ul class="ps-0 mb-0" style="align-content: center; margin-top: 2ch; text-align: center">
                            <li class="ps-0 mb-0" :style="{ 'list-style-type': 'none' }">
                              <div class="justify-content-between align-items-center">
                                <div>
                                  <i class="bx bx-purchase-tag-alt me-2"></i>
                                  <a class="font-weight-semibold font-size-12 ">Val. Médio por CTe: </a>
                                </div>
                                <div class="d-inline ">
                                  <a class="badge badge-soft-warning text-dark font-size-16 mb-1" style="min-width: 14ch">R$
                                    {{ formatDecimal(totalizadores.valorfretmedia) }}</a>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>

                        <div class="col-xl-1"
                             style="float:left; max-width:360px;max-height:360px;margin-left:50px; border-left:1px solid #c5c6ca"></div>

                        <div class="row col-xl-2">
                          <ul class="ps-0 mb-0" style="align-content: center; text-align: center">
                            <li class="ps-0 mb-0" :style="{ 'list-style-type': 'none' }">
                              <div class="justify-content-between align-items-center">
                                <div>
                                  <i class="bx bx-purchase-tag-alt me-2"></i>
                                  <a class="font-weight-semibold font-size-12">Frete Kg:</a>
                                </div>
                                <div class="d-inline">
                                  <a class="badge badge-soft-warning text-dark font-size-16 mb-1" style="min-width: 14ch">R$
                                    {{ formatDecimal(totalizadores.valorfretekg) }}</a>
                                </div>
                              </div>
                            </li>
                          </ul>
                          <ul class="ps-0 mb-0" style="align-content: center; margin-top: 2ch; text-align: center">
                            <li class="ps-0 mb-0" :style="{ 'list-style-type': 'none' }">
                              <div class="justify-content-between align-items-center">
                                <div>
                                  <i class="bx bx-purchase-tag-alt me-2"></i>
                                  <a class="font-weight-semibold font-size-12">Frete %:</a>
                                </div>
                                <div class="d-inline">
                                  <a class="badge badge-soft-warning text-dark font-size-16 mb-1" style="min-width: 14ch">
                                    {{ formatDecimal(totalizadores.valorfretperc) }} %</a>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-1 align-self-center d-none d-lg-block d-flex justify-content-end">
                <div class="clearfix mt-4 mt-lg-0">
                  <b-dropdown
                      class="float-end"
                      right
                      variant="primary"
                      menu-class="dropdown-menu-end"
                  >
                    <template v-slot:button-content>
                      <i class="bx bx-filter-alt search-icon align-middle me-1"></i> Filtro
                    </template>
                    <b-dropdown-item><span class=" font-size-14">Emitente</span>
                      <b-form-checkbox
                          switch size="lg"
                          :value="true"
                          :unchecked-value="false"
                          @change="handleCheckbox('exibEmit')"
                          v-model="exibEmit">
                        <span class=" font-size-12">{{ exibEmit === true ? 'Sim' : 'Não' }}</span>
                      </b-form-checkbox>
                    </b-dropdown-item>

                    <b-dropdown-item><span class=" font-size-14">Destinatário</span>
                      <b-form-checkbox
                          switch size="lg"
                          :value="true"
                          :unchecked-value="false"
                          @change="handleCheckbox('exibDest')"
                          v-model="exibDest">
                        <span class=" font-size-12">{{ exibDest === true ? 'Sim' : 'Não' }}</span>
                      </b-form-checkbox>
                    </b-dropdown-item>

                    <b-dropdown-item><span class=" font-size-14">Ambos</span>
                      <b-form-checkbox
                          switch size="lg"
                          :value="true"
                          :unchecked-value="false"
                          @change="handleCheckbox('exibAmbos')"
                          v-model="exibAmbos">
                        <span class=" font-size-12">{{ exibAmbos === true ? 'Sim' : 'Não' }}</span>
                      </b-form-checkbox>
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Loader class="mt-4" v-if="updating" style="min-height: 150px;"></Loader>

    <div class="row" v-if="!updating">
      <div v-for="stat of cardsData" :key="stat.icon" class="col-md-4">
        <Stat :icon="stat.icon" :title="stat.title" :value="stat.value"/>
      </div>

      <div class="col-xl-5">
        <div class="card">
          <div>
            <div class="row">
              <div class="col-12 mb-2">
                <div class="d-flex" style="margin-left: 2ch; margin-bottom: 1ch;">

                  <div class="avatar-md me-3"
                       style="position: absolute; top: 5ch; left: 8ch; width: 150px; height: 150px;">
                    <span class="avatar-title rounded-circle bg-light text-danger font-size-22 text-center">
                    <h1 :class="`avatar-title rounded-circle bg-soft bg-primary text-primary `" style="font-size: 3ch">
                      {{ selectedDropdown ? selectedDropdown.estado : "" }}</h1>
                    </span>
                  </div>

                  <div class="col-8 text-primary p-1" style="margin-left: 26ch ">
                    <b-form-select v-model="selectedDropdown" block variant="outline" class="m-md-2 text-left"
                                   style="position: absolute; top: 1ch; left: 29ch; width: 50ch;">
                      <template #first>
                        <b-form-select-option :value="null" disabled>Selecione um Estado</b-form-select-option>
                      </template>

                      <template v-for="(transporGroup, index) in chunkedEstadoDestaque" :key="index">
                        <b-form-select-option v-for="transpor in transporGroup" :key="transpor.id" :value="transpor">
                          {{ transpor.estadoPorExtenso }} ({{ transpor.estado }})
                        </b-form-select-option>
                      </template>
                    </b-form-select>
                    <br> <br> <br>

                    <span>Estado Destaque Selecionado:</span>

                    <h5 class="font-size-18 mb-3">{{ selectedDropdown ? selectedDropdown.estadoPorExtenso : "" }} ({{ selectedDropdown ? selectedDropdown.estado : "" }})</h5>
                    <p class="mb-3" style="font-size: 16px">Quant.: {{ selectedDropdown ? selectedDropdown.quantidadeTotal : 0}} CTe's</p>
                    <br>
                  </div>
                </div>

                <div class="mt-5 mb-3 align-self-center">
                  <div class="row">
                    <div class="col-4 text-lg-center">
                      <div>
                        <p class="text-muted text-truncate mb-2 font-size-16">SLA %</p>
                        <span
                            class="badge badge-soft-warning text-dark font-size-16"
                            style="min-width: 14ch"> {{ formatDecimal( selectedDropdown ? selectedDropdown.sla_percentual : 0) }}</span>

                      </div>
                    </div>
                    <div class="col-4 text-lg-center">
                      <div>
                        <p class="text-muted text-truncate mb-2 font-size-16">Valor Carga</p>
                        <span
                            class="badge badge-soft-warning text-dark font-size-16"
                            style="min-width: 14ch">R$ {{ formatDecimal( selectedDropdown ? selectedDropdown.valorcarga : 0) }}</span>
                      </div>
                    </div>

                    <div class="col-4 text-lg-center">
                      <div>
                        <p class="text-muted text-truncate mb-2 font-size-16">Valor Frete</p>
                        <span
                            class="badge badge-soft-warning text-dark font-size-16"
                            style="min-width: 14ch">R$ {{ formatDecimal( selectedDropdown ? selectedDropdown.totalCarga : 0) }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mt-4 mb-3 align-self-center">
                  <div class="row">
                    <div class="col-4 text-lg-center">
                      <div>
                        <p class="text-muted text-truncate mb-2 font-size-16">Peso</p>
                        <span
                            class="badge badge-soft-warning text-dark font-size-16"
                            style="min-width: 14ch">{{ formatDecimal( selectedDropdown ? selectedDropdown.pesoTotal : 0) }} Kg</span>
                      </div>
                    </div>
                    <div class="col-4 text-lg-center">
                      <div>
                        <p class="text-muted text-truncate mb-2 font-size-16">Frete %</p>
                        <span class="badge badge-soft-warning text-dark font-size-16"
                              style="min-width: 14ch">{{ formatDecimal( selectedDropdown ? selectedDropdown.percentualFrete : 0) }}</span>
                      </div>
                    </div>

                    <div class="col-4 text-lg-center mb-3">
                      <div>
                        <p class="text-muted text-truncate mb-2 font-size-16">Frete Kg</p>
                        <span class="badge badge-soft-warning text-dark font-size-16"
                              style="min-width: 14ch">{{ formatDecimal( selectedDropdown ? selectedDropdown.freteKg : 0) }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-7">
        <div class="card">
          <div class="card-body">
            <div class="clearfix">
              <h4 class="card-title mb-4">Custo Frete Percetual Mês</h4>
            </div>

            <div class="row">
              <div class="col-lg-4">
                <div class="text-muted">
                  <div class="mb-4">
                    <p> Total de Frete Mês</p>
                    <h4>R$ {{ formatDecimal( selectedDropdown ? selectedDropdown.totalCarga : 0) }}</h4>
                    <div>
                      <a class="badge badge-soft-success font-size-12 mb-1">
                        {{ selectedDropdown ? selectedDropdown.quantidadeTotal : 0}} Cte's</a>
                      embarcados no mês
                    </div>
                    <br>

                    <ul class="ps-3 mb-0">
                      <li class="py-1">Valor Total Embarcado: <br>
                        <a class="font-size-13 mb-1" style="min-width: 10ch">
                          R$ {{ formatDecimal( selectedDropdown ? selectedDropdown.valorcarga : 0) }}
                        </a>
                      </li>
                      <li class="py-1">Peso Total Embarcado: <br>
                        <a class="font-size-13 mb-1" style="min-width: 10ch">
                          {{ formatDecimal( selectedDropdown ? selectedDropdown.pesoTotal : 0) }} Kg
                        </a>
                      </li>
                    </ul>
                    <div class="d-flex mt-2">
                      <div class="col-3 text-lg-center">
                        <div>
                          <p class="text-dark text-truncate mb-1 font-size-12">Quant. Vol.</p>
                          <span class="badge badge-soft-warning text-dark font-size-13"
                                style="min-width: 8ch">{{ formatInteger( selectedDropdown ? selectedDropdown.volqtd : 0) }}</span>
                        </div>
                      </div>
                      <div class="col-4 text-lg-center" style="margin-left: 1.5ch">
                        <div>
                          <p class="text-dark text-truncate mb-1 font-size-12">Frete por Vol.</p>
                          <span class="badge badge-soft-warning text-dark font-size-13"
                                style="min-width: 8ch">R$ {{ formatDecimal( selectedDropdown ? selectedDropdown.freteVol : 0) }}</span>
                        </div>
                      </div>
                      <div class="col-5 text-lg-center" style="margin-left: 1.5ch">
                        <div>
                          <p class="text-dark text-truncate mb-1 font-size-12">Val. Médio por Vol.</p>
                          <span class="badge badge-soft-warning text-dark font-size-13"
                                style="min-width: 8ch">R$ {{ formatDecimal( selectedDropdown ? selectedDropdown.ticketMedioVol : 0) }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <router-link to="/movctes/listnova" class="btn btn-dark btn-sm">
                      Mais detalhes
                      <i class="mdi mdi-chevron-right ml-1"></i>
                    </router-link>
                  </div>
                  <br>
                </div>
              </div>

              <div class="col-lg-8">
                <div id="line-chart"></div>
                <apexchart
                    v-if="chartFreteMes !== null"
                    class="apex-charts"
                    dir="ltr"
                    height="300"
                    :series="selectedDropdown ? chartFreteMes[selectedDropdown.estado] ?? [chartFreteMes[0]]: [chartFreteMes[0]]"
                    :options="chartOptions"
                ></apexchart>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="!updating">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row ">

              <div id="carouselExampleCaption" class="carousel slide" data-bs-ride="carousel" data-bs-interval="10000">
                <div class="carousel-inner" role="listbox">

                  <div v-for="(transporGroup, index) in chunkedListaResultado" :key="index" class="carousel-item"
                       :class="{ active: index === 0 }">
                    <div class="col-lx-12">
                      <div class="row">
                        <div v-for="transpor in transporGroup" :key="transpor.id" class="col-xl-3">
                          <div class="card">
                            <div style="border: 10px solid #fff;">
                              <div class="d-flex">
                                <div class="avatar-md me-1">
                                    <span
                                        class="avatar-title rounded-circle bg-light text-danger font-size-16 text-center">
                                      <span
                                          :class="`avatar-title rounded-circle bg-soft bg-primary text-primary font-size-16`">
                                        {{ transpor.estado.substr(0, 2) }}
                                      </span>
                                    </span>
                                </div>
                                <div class="flex-grow-1 overflow-hidden">

                                  <div class="flex-grow-1 overflow-hidden">
                                    <div class="col-xl-12">
                                      <!-- Primeira coluna do card -->
                                      <div class="row col-lg-18 mb-3">
                                        <div class="col-3 font-size-11 float-left">
                                          Qtd Cte's <span class="text-primary fs-8 fw-bold d-block">
                                              {{ formatInteger(transpor.quantidadeTotal) }}</span>
                                        </div>

                                        <div class="col-4 font-size-11 float-left">
                                          Peso Kg <span class="text-primary fs-8 fw-bold d-block">
                                            {{ formatDecimal(transpor.pesoTotal) }}</span>
                                        </div>

                                        <div class="col-5 font-size-11">
                                          Valor Carga <span class="text-primary fs-8 fw-bold d-block">
                                              R$ {{ formatDecimal(transpor.valorcarga) }}</span>
                                        </div>
                                      </div>

                                      <div class="row col-lg-16">
                                        <div class="col-3 font-size-11">
                                          Frete Kg <span class="text-primary fs-8 fw-bold d-block">
                                              R$ {{ formatDecimal(transpor.freteKg) }}</span>
                                        </div>

                                        <div class="col-4 font-size-11">
                                          Média CTe <span class="text-primary fs-8 fw-bold d-block">R$
                                            {{ formatDecimal(transpor.mediaCte) }}</span>
                                        </div>

                                        <div class="col-5 font-size-11">
                                          Total Frete <span class="text-primary fs-8 fw-bold d-block">
                                            R$ {{ formatDecimal(transpor.totalCarga) }}</span>
                                        </div>
                                      </div>
                                      <hr>
                                      <div class="row">
                                        <div class="col text-center fs-6">
                                          Frete %: <a class="badge badge-soft-success  font-size-13 mb-1"
                                                      style="min-width: 8ch">
                                          {{ Number(transpor.percentualFrete).toFixed(3) }}%</a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <a class="carousel-control-prev" href="#carouselExampleCaption" role="button" data-bs-slide="prev">
                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span class="visually-hidden">Previous</span>
                </a>
                <a class="carousel-control-next" href="#carouselExampleCaption" role="button" data-bs-slide="next">
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                  <span class="visually-hidden">Next</span>
                </a>
              </div>

              <div class="mt-4 text-end">
                <button class="dropdown-item text-primary text-center"
                        @click="isOpen1 = true"
                        href="javascript: void(0);">
                  Mais Detalhes <i class="bx bx-archive-out"></i>
                </button>
              </div>

              <div class="col-sm-6 col-md-4 col-xl-3">
                <div class="my-4 text-center">
                  <b-modal
                      v-model="isOpen1"
                      id="modal-xl"
                      size="xl"
                      title="Mais Detalhes"
                      title-class="font-18"
                      hide-footer
                  >

                    <div class="table-responsive" >
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th class="text-center">Estado</th>
                          <th class="text-center">Qtd. CTe</th>
                          <th class="text-center">Peso Kg</th>
                          <th class="text-center">Valor Carga</th>
                          <th class="text-center">Frete Kg</th>
                          <th class="text-center">Média CTe</th>
                          <th class="text-center">Total Frete</th>
                          <th class="text-center">Frete %</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(transpor, index) in listaResultado" :key="index.estado">
                          <td class="text-center">
                            <span class="badge bg-dark text-wrap fs-1" style="min-width: 17ch">
                              {{ transpor.estadoPorExtenso }}
                            </span>
                          </td>
                          <td class="text-center">
                            <span class="text-primary fs-8 fw-bold d-block">
                              {{ formatInteger(transpor.quantidadeTotal) }} Cte's
                            </span>
                          </td>
                          <td class="text-center">
                            <span class="text-primary fs-8 fw-bold d-block">
                              {{ formatDecimal(transpor.pesoTotal) }} Kg
                            </span>
                          </td>
                          <td class="text-center">
                            <span class="text-primary fs-8 fw-bold d-block">R$
                              {{ formatDecimal(transpor.valorcarga) }}
                            </span>
                          </td>
                          <td class="text-center">
                            <span class="text-primary fs-8 fw-bold d-block">R$
                              {{ formatDecimal(transpor.freteKg) }}
                            </span>
                          </td>
                          <td class="text-center">
                            <span class="text-primary fs-8 fw-bold d-block">R$
                              {{ formatDecimal(transpor.mediaCte) }}
                            </span>
                          </td>
                          <td class="text-center">
                            <span class="text-primary fs-8 fw-bold d-block">R$
                              {{ formatDecimal(transpor.totalCarga) }}
                            </span>
                          </td>
                          <td class="text-center">
                            <span class="text-primary fs-8 fw-bold d-block">
                              {{ Number(transpor.percentualFrete).toFixed(3) }}%
                            </span>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>

                  </b-modal>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Data Inicial e Final</label>

        </div>
      </div>
      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
            <div v-if="submittedPeriodo && !dtIniFiltro"
                 class="invalid-feedback">
              <span>Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
            <div v-if="submittedPeriodo && !dtFimFiltro"
                 class="invalid-feedback">
              <span>Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>

      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>
  </Layout>
</template>